import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import TruncatedTextWithTooltip from "app/pages/sales-intelligence/common-components/TruncatedText/TruncatedTextWithTooltip";

export const StyledTopCompanyListIconWrapper = styled.span`
    display: inline-block;
    position: relative;
    width: 16px;
    height: 16px;
    overflow: hidden;

    ${SWReactIcons} {
        position: absolute;
        top: 0;
    }
`;
export const StyledTopCompanyListLinkWrapper = styled.div`
    width: calc(100% - 14px);
`;
export const StyledTopCompanyListNameWrapper = styled(TruncatedTextWithTooltip)`
    &:hover {
        color: ${colorsPalettes.carbon[400]};
        text-decoration-line: underline;
        text-decoration-style: solid;

        ${SWReactIcons} svg {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;
